<template lang="pug">
  .drawing
    h6.title Product Data Drawing
    .images
      img(:src="products.connectors[0].drawingImage")      
      img(:src="products.connectors[1].drawingImage")
    data.calculation {{calculation[0]}}
</template>
<script>
export default {
  name: "ProductSheetDrawing",
  props: ["products"],
  computed: {
    calculation() {      
      return [this.products.performance.lengthVariance];
    }
  },
}
</script>


<style lang="scss" scoped>
.drawing {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 2rem;
  align-self: center;
  max-width: 100%;
  flex: 0 1 auto;
}

.title {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 1rem;
  letter-spacing: 0.25px;
}

.images {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  flex: 0 1 auto;
  max-width: 100%;
  img {
    flex: 0 1 auto;
    max-width: calc(50% - 0.25rem);
  }
}

.calculation {
  font-size: 0.875rem;
  font-weight: 700;
  margin: 1rem 0 0;
}
</style>